<template>
    <span>
        <i class="cus-comments" :class="{ blink: hasUnread }"></i>Inbox
    </span>
</template>
<script>
export default {
    mounted() {},
    computed: {
        hasUnread() {
            return this.$store.state.conversation.hasUnread;
        }
    }
};
</script>
<style scoped>
.blink {
    animation: displace 2s linear infinite;
}
@keyframes displace {
    0%,
    50% {
        background-image: url(../../../public/assets/icons/comments.png);
    }
    51%,
    100% {
        background-image: url(../../../public/assets/icons/comments_blink.png);
    }
}
</style>
